import { injectable, Inject } from 'inversify-props';
import moment from 'moment';

@injectable()
export class TimeService {
    constructor() {
    }

    public dateFormat(date: string) {
        return moment(date, 'DDMMYY').format("ddd DD-MMM-YYYY")
    }

    public timeFormat(time: string) {
        return moment(time, 'HHmm').format('HH:mm')
    }

    public flightTimeFormat(time: number) {
        let sec = time * 60;
        let hours: string = Math.floor(sec / 3600).toString();
        let minutes: string = Math.floor((sec - (+hours * 3600)) / 60).toString();

        if (+hours < 10) { hours = "0" + hours; }
        if (+minutes < 10) { minutes = "0" + minutes; }
        return hours + ' h ' + minutes + ' mins';
    }

}
